class ScrollingMarquee extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    const { speed } = this.dataset;
    const clone = this.innerHTML;
    const firstElement = this.children[0];
    let i = 0;

    this.insertAdjacentHTML('beforeend', clone);
    this.insertAdjacentHTML('beforeend', clone);

    setInterval(() => {
      firstElement.style.marginLeft = `-${i}px`;

      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i += Number(speed);
    }, 10);
  }
}

customElements.define('scrolling-marquee', ScrollingMarquee);
